import React from "react"
import Img from "@kframesa/react-crosscast-lazy-image"
import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from "react-share"

import { BlogPostSEO } from "./seo"
import Player from "./blog-post/player"
import Relateds from "./relateds"

import { sPost } from "../styled/blog-post"
import { Pic } from "../styled/pic-info"
import "../assets/css/swiper.css"
import facebook from "../assets/images/facebook.svg"
import pinterest from "../assets/images/pinterest.svg"
import twitter from "../assets/images/twitter.svg"
import whatsapp from "../assets/images/whatsapp.svg"
import email from "../assets/images/email.svg"

import { getFluidImageUrl, getPostUrl, getCategoryUrl } from "../utilities"
import { TravelsProvider } from "../contexts/travels-context"
import { sLayout } from "../styled/layout"

const Post = ({ children, post, relateds, canonicalUrl, lang }) => (
  <>
    <BlogPostSEO post={post} />
    <TravelsProvider>
      <sPost.Wrapper>
        <sPost.Header>
          <sPost.Container>
            <h1>{post.title}</h1>
            <span>
              {`${post.author ? `${post.author}, ` : ``}`}
              {post.publishedAtFormatted ? post.publishedAtFormatted : ``}
            </span>
            {post.abstract ? <p>{post.abstract}</p> : null}
          </sPost.Container>
        </sPost.Header>
        <sPost.Featured>
          {post.launchImage ? (
            <>
              {post.launchImage.credits ? <Pic.Credits>{post.launchImage.credits}</Pic.Credits> : null}
              <Img
                platformSlug={post.launchImage.platformSlug}
                imageGuid={post.launchImage.guid}
                fluid={{
                  maxWidth: 960,
                  size: 425,
                  step: 343,
                  sizes: [`(max-width: 425px) 425px`, `(max-width: 768px) 768px`, `960px`],
                }}
                title={post.launchImage.title}
                alt={post.launchImage.alt}
                width={post.launchImage.width}
                height={post.launchImage.height}
                ext={post.launchImage.ext}
              />
              {post.launchImage.caption ? <Pic.Caption>{post.launchImage.caption}</Pic.Caption> : null}
            </>
          ) : null}
          {post.launchVideoSrc ? <Player src={post.launchVideoSrc} /> : null}
        </sPost.Featured>
        <sPost.Body>
          <sPost.Container>{children}</sPost.Container>
        </sPost.Body>
        <sPost.Footer>
          <sPost.Container>
            {post.categories ? (
              <sPost.Tags>
                {post.categories.map(category => (
                  <li key={category.categoryId}>
                    <sLayout.Button to={getCategoryUrl(category.slug)} key={category.slug}>
                      {category.name}
                    </sLayout.Button>
                  </li>
                ))}
              </sPost.Tags>
            ) : null}
            <sPost.Share>
              <span>{lang === `it` ? `Condividi` : `Share`}</span>
              <FacebookShareButton url={`${canonicalUrl}${getPostUrl(post.slug)}`}>
                <span className="visuallyhidden">Facebook</span>
                <img src={facebook} alt="Facebook" width="22" height="22" />
              </FacebookShareButton>
              <PinterestShareButton
                url={`${canonicalUrl}${getPostUrl(post.slug)}`}
                media={getFluidImageUrl(
                  post.featuredImage.guid,
                  post.featuredImage.type,
                  post.featuredImage.platformSlug
                )}
                description={post.title}
              >
                <span className="visuallyhidden">Pinterest</span>
                <img src={pinterest} alt="Pinterest" width="22" height="22" />
              </PinterestShareButton>
              <TwitterShareButton url={`${canonicalUrl}${getPostUrl(post.slug)}`} title={post.title}>
                <span className="visuallyhidden">Twitter</span>
                <img src={twitter} alt="Twitter" width="22" height="22" />
              </TwitterShareButton>
              <WhatsappShareButton url={`${canonicalUrl}${getPostUrl(post.slug)}`} title={post.title}>
                <span className="visuallyhidden">Whatsapp</span>
                <img src={whatsapp} alt="Whatsapp" width="22" height="22" />
              </WhatsappShareButton>
              <EmailShareButton url={`${canonicalUrl}${getPostUrl(post.slug)}`} subject={post.title} openWindow>
                <span className="visuallyhidden">Email</span>
                <img src={email} alt="Email" width="22" height="22" />
              </EmailShareButton>
            </sPost.Share>
          </sPost.Container>
        </sPost.Footer>
        {post.relateds ? (
          <sPost.Related>
            <h2>{lang === `it` ? `Leggi anche` : `Recommended for you`}</h2>
            <Relateds posts={post.relateds || relateds} />
          </sPost.Related>
        ) : null}
      </sPost.Wrapper>
    </TravelsProvider>
  </>
)

export default Post
